export const visit = (vm, at) => {
vm(require("foundations-components/lang/zh-tw.lyaml"));
at({ "zh-tw": { "placeholder": "\u9810\u7559\u4F4D\u7F6E" } });
};